// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove-right-padding[data-v-4f31453c]{padding-right:0}", ""]);
// Exports
module.exports = exports;
